/**
 * Runtime environment helper
 * Reads from window.__ENV__ (injected at runtime) with fallback to import.meta.env (build time)
 */

declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

/**
 * Get environment variable with runtime override support
 * Priority: window.__ENV__ > import.meta.env > defaultValue
 */
export function getEnv(key: string, defaultValue = ''): string {
  // Runtime environment (from docker-entrypoint.sh)
  if (typeof window !== 'undefined' && window.__ENV__?.[key]) {
    return window.__ENV__[key];
  }

  // Build-time environment (Vite)
  const buildTimeValue = import.meta.env[key];
  if (buildTimeValue && !buildTimeValue.startsWith('__RUNTIME_')) {
    return buildTimeValue;
  }

  return defaultValue;
}

// Pre-defined environment getters for type safety
export const env = {
  get VITE_API_URL() {
    return getEnv('VITE_API_URL', 'http://localhost:3000');
  },
  get VITE_APP_NAME() {
    return getEnv('VITE_APP_NAME', 'Volovolo Pro');
  },
  get VITE_APP_VERSION() {
    return getEnv('VITE_APP_VERSION', '1.0.0');
  },
  get VITE_DEFAULT_CURRENCY() {
    return getEnv('VITE_DEFAULT_CURRENCY', 'XOF');
  },
  get isDev() {
    return import.meta.env.DEV;
  },
};
